
import {throwError as observableThrowError,  Observable ,  Observer } from 'rxjs';
/*import { Injectable } from '@angular/core';

@Injectable()
export class SocketService {

  constructor() { }

}

*/
import { Injectable } from '@angular/core';
// import * as socketIo from 'socket.io-client';
import { io, Socket } from 'socket.io-client';
// import { Socket } from './socket-interface';
import { UserDetailsService } from '../services/user-details.service';

// declare let io : {
//   connect(url: string): Socket;
// };

@Injectable()
export class SocketService {

  socket: Socket;
  observer: Observer<any>;
  url:string;
  sessionId : string;
  constructor(
    private userDetailsService:UserDetailsService,
  ){}

  connectToScoket(url, sessionId) {
    if (sessionId){
      this.url = url;
      this.sessionId= sessionId;

      // this.socket = socketIo(url);
      this.socket = io(url);

      this.socket.on('connect', () => {

        this.socket.emit("setAuthCode", sessionId);
        this.socket.on('message', data => {
          if (data['messageName'] && data['messageName'].includes("PushRealBalance")) {
            this.userDetailsService.setUserCashBalance(Number(data["cashBalance"]));
            this.userDetailsService.setUserBonusBalance(Number(data["bonusBalance"]));
            this.userDetailsService.setUserTotalBalance(Number(data["cashBalance"]) + Number(data["bonusBalance"]));
          }
          if (data['messageName'] && data['messageName'].includes("PushLogoutEvent")) {
            this.userDetailsService.doLogout();
          }
        });
        // this.socket.on('disconnect', data => {
        //   this.connectToScoket(this.url, this.sessionId);
        // });
      });
    }
  }



  private handleError(error) {
    if (error.error instanceof Error) {
      let errMessage = error.error.message;
      return observableThrowError(errMessage);
    }
    return observableThrowError(error || 'Socket.io server error');
  }

}